import { render, staticRenderFns } from "./InsumosMaquinas.vue?vue&type=template&id=7f2d639c&"
import script from "./InsumosMaquinas.vue?vue&type=script&lang=js&"
export * from "./InsumosMaquinas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports